import gql from 'graphql-tag';
import { apollo } from 'src/features';

const mutation = gql`
mutation ResetPassword($login: String!, $code: String!) {
  resetPassword(login: $login, confirmationCode: $code)
}`;

function resetPassword({ login, code }) {
  return apollo.client.mutate({
    variables: {
      login,
      code,
    },
    mutation,
  })
    .then((res) => res.data.resetPassword)
    .catch((err) => {
      if (err.graphQLErrors.length) {
        throw err.graphQLErrors[0].error.code;
      } else {
        throw err;
      }
    });
}

export default resetPassword;
